import React from "react";

function BS4_JS_Alert() {
  return (
    <div>
      <h1>BS4_JS_Alert Component</h1>
      <p>This is the BS4_JS_Alert tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Alert;
